import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Floatingcall from "../components/floatingbutton/Floatingcall";
import { Helmet } from "react-helmet";
import LandingPageClient from "../components/ladingpageclient/LandingPageClient";
import {FaBroom} from "react-icons/fa";

function CommercialCleaningServices() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

     const testimonials = [
  {
    name: "Rahul Sharma",
    role: "Business Owner",
    feedback:
      "We were getting cleanliness complaints almost every week. After Helper Ji’s commercial cleaning team started, the situation improved gradually. Now the office stays clean most of the day.",
    image: "https://i.pravatar.cc/150?img=12",
  },
  {
    name: "Neha Verma",
    role: "Working Professional",
    feedback:
      "Helper Ji cleaning staff doesn’t rush the work. Floors, desks, and washrooms are cleaned properly, which we didn’t get from earlier vendors.",
    image: "https://i.pravatar.cc/150?img=32",
  },
  {
    name: "Amit Singh",
    role: "Corporate Manager",
    feedback:
      "We started with basic cleaning from Helper Ji, and later added more areas because the service quality stayed consistent.",
    image: "https://i.pravatar.cc/150?img=56",
  },
];
const services = [
    {
      name: "Commercial Cleaning Services Noida",
      link: "/commercial-cleaning-services-noida",
      icon: <FaBroom />
    },
    {
      name: "Commercial Cleaning Services Ghaziabad",
      link: "/commercial-cleaning-services-ghaziabad",
      icon: <FaBroom />
    },
    {
      name: "Commercial Cleaning Services Delhi",
      link: "/commercial-cleaning-services-delhi",
      icon: <FaBroom />
    }
  ];

  return (
    <Fragment>
      <Helmet>
        {/* BASIC META */}
    <title>Best Commercial Office Cleaning Services in Gurgaon by Trusted Cleaning Experts</title>
    <meta
      name="description"
      content="Hire professional commercial cleaning services in Gurgaon offering deep office cleaning services, corporate cleaning solutions from a trusted commercial cleaning company."
    />
    <meta
      name="keywords"
      content="Commercial Office Cleaning Services In Gurgaon, Best Commercial Cleaning Services In Gurgaon, Office Cleaning Services In Gurgaon, Deep Office Cleaning Services In Gurgaon, Commercial Cleaning Services Company In Gurgaon, Professional Commercial Cleaning Services In Gurgaon"
    />

    {/* ROBOTS */}
    <meta name="robots" content="index, follow" />
    <meta name="googlebot" content="index, follow" />
    <meta name="bingbot" content="index, follow" />
    <meta name="revisit-after" content="daily" />
    <meta name="copyright" content="Helper Ji" />

    {/* CANONICAL */}
    <link
      rel="canonical"
      href="https://www.helperji.in/commercial-cleaning-services-gurugram"
    />

    {/* OPEN GRAPH */}
    <meta
      property="og:title"
      content="Best Commercial Office Cleaning Services in Gurgaon by Trusted Cleaning Experts"
    />
    <meta
      property="og:description"
      content="Experience professional commercial cleaning services delivered by a trusted commercial cleaning company. We provide corporate cleaning & commercial office cleaning services."
    />
    <meta
      property="og:image"
      content="https://www.helperji.in/assets/img/officeclean.jpg"
    />
    <meta property="og:site_name" content="Helper Ji" />
    <meta
      property="og:url"
      content="https://www.helperji.in/commercial-cleaning-services-gurugram"
    />
    <meta property="og:type" content="website" />

    {/* TWITTER */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@helperji_" />
    <meta name="twitter:creator" content="@helperji_" />
    <meta
      name="twitter:title"
      content="Best Commercial Office Cleaning Services in Gurgaon by Trusted Cleaning Experts"
    />
    <meta
      name="twitter:description"
      content="Experience professional commercial cleaning services delivered by a trusted commercial cleaning company. We provide corporate cleaning & commercial office cleaning services."
    />
    <meta
      name="twitter:image"
      content="https://www.helperji.in/assets/img/officeclean.jpg"
    />

    {/* WEBPAGE SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "url": "https://www.helperji.in/commercial-cleaning-services-gurugram",
        "name": "Best Commercial Office Cleaning Services in Gurgaon by Trusted Cleaning Experts",
        "description": "Experience professional commercial cleaning services delivered by a trusted commercial cleaning company. We provide corporate cleaning & commercial office cleaning services."
      }
      `}
    </script>

    {/* PRODUCT SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Commercial Cleaning Services in Gurgaon",
        "image": "https://www.helperji.in/assets/img/officeclean.jpg",
        "description": "Experience professional commercial cleaning services delivered by a trusted commercial cleaning company. We provide corporate cleaning & commercial office cleaning services.",
        "brand": {
          "@type": "Brand",
          "name": "Helper Ji"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "ratingCount": "498"
        }
      }
      `}
    </script>

    {/* BREADCRUMB SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://www.helperji.in"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Commercial Cleaning Services in Gurgaon",
            "item": "https://www.helperji.in/commercial-cleaning-services-gurugram"
          }
        ]
      }
      `}
    </script>

    {/* FAQ SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What types of offices do you serve in Gurgaon?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We provide office cleaning services in Gurgaon for corporate offices, startups, and business parks."
            }
          },
          {
            "@type": "Question",
            "name": "Do you provide office deep cleaning services in Gurgaon?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, our office deep cleaning services in Gurgaon cover detailed cleaning of floors, furniture, equipment, and common areas."
            }
          },
          {
            "@type": "Question",
            "name": "Are your commercial cleaning services in Gurgaon suitable for daily cleaning?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, our commercial cleaning services in Gurgaon can be scheduled daily, weekly, or as required."
            }
          },
          {
            "@type": "Question",
            "name": "Do you offer corporate cleaning services in Gurgaon?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we provide reliable corporate cleaning services designed for professional business environments."
            }
          },
          {
            "@type": "Question",
            "name": "Are your cleaning methods safe for office equipment?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we use approved tools and methods to safely perform office cleaning services in Gurgaon without harming electronics."
            }
          }
        ]
      }
      `}
    </script>
      <script type="text/javascript">
    {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
  </script>
      </Helmet>
      <Floatingcall />
      <section id="about" class="about">
        <div class="container" data-aos="fade-up">
          <div class="section-header">
            <h2>COMMERCIAL CLEANING SERVICES IN GURGAON</h2>
            <p>
              Affordable Corporate Cleaning Services in Gurgaon
            </p>
          </div>

          <div class="row gy-4">
            <div class="col-lg-6">
              <img
                src="/assets/img/officeclean.jpg"
                class="img-fluid rounded-4 mb-4"
                alt=""
              />
            </div>

            <div class="col-lg-6">
              <div class="content ps-0 ps-lg-5">
                <p className="text-justify">
                 Helper Ji provides reliable office cleaning services in Gurgaon for offices that require regular upkeep and deep hygiene. Our services are suitable for corporate offices, startups, and business parks that prioritise a clean and organised workspace.
                </p>
                <p className="text-justify">
                  We specialise in commercial cleaning services in Gurgaon, offering systematic and well-managed cleaning routines tailored to each office’s needs. Our trained team ensures workspaces remain hygienic, organised, and comfortable without disrupting daily business operations.
                </p>
             <p className="text-justify">Our office deep cleaning services in Gurgaon are designed to meet the unique requirements of different businesses. Whether it’s routine cleaning or detailed deep cleaning, we follow structured processes to maintain hygiene, reduce dust, and create a healthy working environment.</p>
                <div class="text-left">
                  <Link
                    to="/contact-us"
                    className="booknow"
                    onClick={scrollToTop}
                  >
                    Book Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="services" class="services sections-bg">
        <div class="container" data-aos="fade-up">
          <div class="row gy-4">
            <div class="col-lg-6">
              <div class="content ps-0 ps-lg-5">
                <h5>Our office cleaning services in Gurgaon cover all major areas of your office:</h5>
                   <ul>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Office floor and tile cleaning for a spotless environment.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Furniture and upholstery cleaning to maintain office assets.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Dusting and careful cleaning of electronic equipment.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Glass cabins and meeting room cleaning for a polished look.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Pantry and common area cleaning to ensure hygiene for shared spaces
                  </li>
                </ul>

                <h5 className="pt-4"> Serving Corporate Hubs Across Gurgaon</h5>
                <p>
                  Our commercial cleaning services in Gurgaon are available throughout major business hubs and office complexes, providing dependable cleaning for offices of all sizes.
                </p>
                <p>Maintain a clean, hygienic, and well-organised workplace with Helper Ji. Book professional office cleaning services today and experience expert cleaning solutions in Gurgaon.</p>
              </div>
            </div>
            <div class="col-lg-6">
              <img
                src="/assets/img/officecleaning.jpg"
                class="img-fluid rounded-4 mb-4"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

        <section className="py-5 bg-white">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">What Our <span style={{ color: "#ED1C24" }}>Clients Say</span> </h2>
          <p className="text-muted">
            Trusted by thousands of satisfied customers
          </p>
        </div>

        {/* Testimonials */}
        <div className="row g-4">
          {testimonials.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="card bg-light h-100 shadow-sm border-0 text-center p-4">
                <img
                  src={item.image}
                  alt={item.name}
                  className="rounded-circle mx-auto mb-3"
                  width="90"
                  height="90"
                />

                <p className="text-muted fst-italic">
                  “{item.feedback}”
                </p>

                <h5 className="fw-semibold mb-0">{item.name}</h5>
                <small className="text-danger">{item.role}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

      <section id="services" class="services sections-bg">
        <div className="container">
          <h3>
            FAQs – COMMERCIAL CLEANING SERVICES IN GURGAON
          </h3>
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  What types of offices do you serve in Gurgaon?
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  We provide office cleaning services in Gurgaon for corporate offices, startups, and business parks.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  Do you provide office deep cleaning services in Gurgaon?
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Yes, our office deep cleaning services in Gurgaon cover detailed cleaning of floors, furniture, equipment, and common areas.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                  Are your commercial cleaning services in Gurgaon suitable for daily cleaning?
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, our commercial cleaning services in Gurgaon can be scheduled daily, weekly, or as required.
                </div>
              </div>
            </div>
             <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour"
                  aria-expanded="false"
                  aria-controls="flush-collapseFour"
                >
                  Do you offer corporate cleaning services in Gurgaon?
                </button>
              </h2>
              <div
                id="flush-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, we provide reliable corporate cleaning services designed for professional business environments.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFive"
                  aria-expanded="false"
                  aria-controls="flush-collapseFive"
                >
                  Are your cleaning methods safe for office equipment?
                </button>
              </h2>
              <div
                id="flush-collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFive"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, we use approved tools and methods to safely perform office cleaning services in Gurgaon without harming electronics.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

         <LandingPageClient />
          <section className="py-5 sections-bg">
               <div className="container">
                 <div className="row mb-4">
                   <div className="col text-center">
                     <h2 className="fw-bold">Other Locations</h2>
                     <p className="text-muted">
                       Explore our other locations of Commercial Cleaning Services
                     </p>
                   </div>
                 </div>
         
                 <div className="row g-4">
                   {services.map((service, index) => (
                     <div className="col-md-4 col-sm-6" key={index}>
                       <Link
                         to={service.link}
                         className="text-decoration-none text-dark"
                       >
                         <div className="card h-100 shadow-sm border-0 service-card">
                           <div className="card-body d-flex align-items-center">
                             <div className="service-icon me-3">
                               {service.icon}
                             </div>
                             <h6 className="mb-0 fw-semibold">
                               {service.name}
                             </h6>
                           </div>
                         </div>
                       </Link>
                     </div>
                   ))}
                 </div>
               </div>
             </section>
    </Fragment>
  );
}

export default CommercialCleaningServices;
